module.exports = __webpack_public_path__ + "img/hexagon.c06fb0bb.svg";